// extracted by mini-css-extract-plugin
export var divider = "_vv-0";